import React, { Component } from 'react';
import { Select, Tooltip } from 'antd';
import AjaxRequest from '../../common/AjaxRequest';

let timeout;
let currentValue;
const Option = Select.Option;

class SearchMulSelect extends Component {
    state = {
        value: [],
        fetching: false,
    }

    componentDidMount() {
        this.handleSearch()
    }
    
    componentWillReceiveProps(nextProps){
        nextProps.value != undefined &&
        this.setState({
            value: nextProps.value
        });
    }

    handleSearch = value => {
        let dyamicParams = {};
        if(this.props.getDynamicParams){
            dyamicParams = this.props.getDynamicParams();
            if(!dyamicParams){
                return;
            }
        }
        
        const { url, parseData, searchParam, keyword } = this.props;
        this.setState({ fetching: true });
        const _this = this;

        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        currentValue = value;

        function fake() {
            const options = {
                method: 'POST',
                url, 
                data: {
                    [keyword]: value,
                    ...searchParam
                },
                dataType: 'json',
                doneResult: (res => {
                    parseData(res);
                }),
            };
            AjaxRequest.sendRequest(options);
        }
        timeout = setTimeout(fake, 500);
    }

    handleChange = value => {
        this.setState({
            value,
            fetching: false,
        }, () => {
            this.props.handleSelect(value);
        });
    }

    render () {
        const { value } = this.state;
        const { style, className, placeholder, sourceData = [] } = this.props;
        return (
            <Select
                mode="multiple"
                labelInValue
                placeholder={placeholder}
                notFoundContent={null}
                filterOption={false}
                onFocus={() => this.handleSearch()}
                onSearch={this.handleSearch}
                onChange={this.handleChange}
                style={style}
                value={value}
                className={className}
            >
                {sourceData.map(d => <Option key={d.value}>
                    <Tooltip placement="right" title={d.text}>
                        <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{d.text}</span>
                    </Tooltip>
                </Option>)}
            </Select>
        )
    }
}

export default SearchMulSelect


// WEBPACK FOOTER //
// ./src/components/common/SearchMulSelect.js